import { usePlayerClubsAndTournamentsQuery } from '@features/user/api/hooks';
import { PlayerClubsAndTournamentsPreview } from '@features/user/ui/PlayerClubsAndTournaments/PlayerClubsAndTournamentsPreview';

type Props = {
  setIsModalOpen: (isOpen: boolean) => void;
};
export function PlayerClubsAndTournamentsPreviewWidget({ setIsModalOpen }: Props) {
  const { data } = usePlayerClubsAndTournamentsQuery();

  const tournaments = data?.myTournaments;
  const clubs = data?.myClubs;

  return (
    <PlayerClubsAndTournamentsPreview
      setIsModalOpen={setIsModalOpen}
      tournaments={tournaments}
      clubs={clubs}
    />
  );
}
